/* eslint-disable react/require-default-props */
import React, { FC, useEffect, useState } from 'react';

import { Button } from '@smiles/voebiz-ui-kit';
import chipsIcon from 'utils/icons/chips.svg';
import starIcon from 'utils/icons/star.svg';
import airPlaneIcon from 'utils/icons/airPlane.svg';
import { Progress } from 'reactstrap';

export interface MyAccountCardProps {
  user: string;
  tier: string;
  voeBizNumber: string;
  voeBizPoints: string;
  voeBizExpiringPoints: string;
  voeBizExpiringDate: string;
  voeBizQualifyingPoints: string;
  voeBizQualifyPointsToNextTier: string;
  voeBizNextTier: string;
  voeBizRenewCategoryDate: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cardSize: any;
}

const MyAccountCard: FC<MyAccountCardProps> = ({
  user,
  tier,
  voeBizNumber,
  voeBizPoints,
  voeBizExpiringPoints,
  voeBizExpiringDate,
  voeBizQualifyingPoints,
  voeBizQualifyPointsToNextTier,
  voeBizNextTier,
  voeBizRenewCategoryDate,
  cardSize,
}) => {
  const [progressBarValue, setProgressBarValue] = useState<number>(0);

  const valueProgressCalculation = (
    // eslint-disable-next-line no-shadow
    tier: string,
    voeBizQualifyPointsToNextTierValue: string,
    voeBizQualifyingPointsValue: string,
  ) => {
    if (tier === 'Prime') {
      setProgressBarValue(100);
    } else {
      const totalValue = parseInt(voeBizQualifyPointsToNextTierValue, 10);
      const percentualValue = parseInt(voeBizQualifyingPointsValue, 10);
      const progressValue = (percentualValue * 100) / totalValue;
      if (progressValue > 100) {
        setProgressBarValue(100);
        return;
      }
      setProgressBarValue(progressValue);
    }
  };

  const handleContinue = () => {
    window.location.href = `/minha-conta/alterar-dados`;
  };

  useEffect(() => {
    valueProgressCalculation(tier, voeBizQualifyPointsToNextTier, voeBizQualifyingPoints);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voeBizQualifyingPoints, voeBizQualifyPointsToNextTier]);
  return (
    <div className="wrapper">
      <div className={!cardSize ? 'user-card' : 'user-card small-card'}>
        <div className="user-card__info__user">
          <span>{user}</span>
        </div>
        <div className={tier === 'Prime' ? 'user-card__info__tier--gray' : 'user-card__info__tier'}>
          {tier === 'Prime' && (
            <img id="" className="user-card__info__tier--star-icon" src={starIcon} alt="Ícone de estrela" />
          )}
          <span className="user-card_info__tier--text">Categoria {tier}</span>
        </div>
        <div className="user-card__info__button">
          <Button type="pill" htmlType="button" className="user-card__button" onClick={handleContinue}>
            Acessar dados da conta
          </Button>
        </div>
        <div className="user-card__voebiz-number">
          <span>Número VoeBiz: {voeBizNumber}</span>
        </div>
        <a className="user-card__miles__points" style={{ textDecoration: 'none' }} href="/minha-conta/extrato">
          <div className="user-card__miles__points">
            <div className="user-card__miles__points--icon">
              <img id="" className="chips_icon" src={chipsIcon} alt="Ícone de moedas" />
            </div>
            <span className="user-card__miles__points--text">
              Pontos VoeBiz: {Intl.NumberFormat('pt-BR').format(Number(voeBizPoints))}
            </span>
            <div className="user-card__miles__points--hoover-message">
              <div className="user-card__miles__points--hoover-message--text">
                <span>Acumule pontos VoeBiz e faça sua empresa voar mais longe!</span>
              </div>
              <hr className="user-card__miles__points--hoover-message--line" />
              <div className="user-card__miles__points--hoover-message--sub-text">
                <span>Compre passagens na GOL. Não se esqueça de informar o número VoeBiz para acumular.</span>
              </div>
            </div>
          </div>
        </a>
        <div className="user-card__miles__expiring-points--number">
          <span>
            Pontos a expirar:{' '}
            {voeBizExpiringPoints !== '0' && voeBizExpiringPoints !== ''
              ? Intl.NumberFormat('pt-BR').format(Number(voeBizExpiringPoints))
              : '-'}
          </span>
        </div>
        {voeBizExpiringPoints !== '0' && voeBizExpiringPoints !== '' && (
          <div className="user-card__miles__expiring-points--date">
            <span>Expiram em: {voeBizExpiringDate}</span>
          </div>
        )}
        {!cardSize && (
          <div className="user-card__qualifying-points">
            <div className="user-card__qualifying-points--title">
              <a style={{ textDecoration: 'none' }} href="/minha-categoria">
                <span>Pontos qualificáveis</span>
              </a>
            </div>
            <div className="user-card__qualifying-points--progress-bar">
              <img
                id=""
                className="user-card__qualifying-points--progress-bar--air-plane-icon"
                src={airPlaneIcon}
                alt="Ícone de avião"
                style={{ marginLeft: `${progressBarValue - 1.5}%` }}
              />
              <Progress animated={false} color="primary" value={progressBarValue} />
              <div
                className="user-card__qualifying-points--progress-bar--value"
                style={{ marginLeft: `${progressBarValue - 2.5}%` }}
              >
                {tier === 'Prime' ? (
                  <span />
                ) : (
                  <span>{Intl.NumberFormat('pt-BR').format(Number(voeBizQualifyingPoints))}</span>
                )}
              </div>
              <div className="user-card__qualifying-points--progress-bar__tiers">
                {tier === 'Prime' ? (
                  <div className="user-card__qualifying-points--progress-bar__tiers--old-tier-prime">
                    <span>Categoria {tier}</span>
                    <div className="user-card__qualifying-points--progress-bar__tiers--old-tier-prime--value">
                      {Intl.NumberFormat('pt-BR').format(Number(voeBizQualifyingPoints))}
                    </div>
                  </div>
                ) : (
                  <div className="user-card__qualifying-points--progress-bar__tiers--old-tier">
                    <span>Categoria {tier}</span>
                  </div>
                )}

                {tier === 'Prime' ? (
                  <div className="user-card__qualifying-points--progress-bar__tiers--category-maintenance">
                    <span className="user-card__qualifying-points--progress-bar__tiers--category-maintenance--text">
                      Renovar categoria
                    </span>
                    <span className="user-card__qualifying-points--progress-bar__tiers--category-maintenance--value">
                      Renova em: {voeBizRenewCategoryDate}
                    </span>
                  </div>
                ) : (
                  <div className="user-card__qualifying-points--progress-bar__tiers--next-tier">
                    <span className="user-card__qualifying-points--progress-bar__tiers--next-tier--text">
                      Categoria {voeBizNextTier}
                    </span>
                    <span className="user-card__qualifying-points--progress-bar__tiers--next-tier--value">
                      {Intl.NumberFormat('pt-BR').format(Number(voeBizQualifyPointsToNextTier))}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default MyAccountCard;
